import { Markdown } from "./Markdown";

const STATUS_ICON = { success: "✅", error: "❌", warning: "⚠️", pending: "🟡", active: "🟢" };

// Tabla de la respuesta: el texto BAJA de renglón (nada se corta por un lado), primera columna en negrita y líneas finas.
export function StatusTableSection({ section }) {
  return (
    <div data-testid="typed-section-status-table" className="my-4 overflow-x-auto">
      <table className="w-full text-base border-collapse table-auto">
        <thead>
          <tr>
            {section.headers.map((h, i) => (
              <th key={i} className="px-4 py-2 text-left font-semibold text-foreground/80 align-top">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {section.rows.map((row, i) => (
            <tr key={i} className="border-t border-foreground/35 first:border-t-0">
              {row.cells.map((cell, j) => (
                <td key={j} className={`px-4 py-2 align-top break-words leading-7 ${j === 0 ? "font-semibold text-foreground/95" : "text-foreground/80"}`}>
                  {j === 0 && row.status ? `${STATUS_ICON[row.status] || ""} ` : ""}
                  <Markdown text={String(cell)} inline />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
